import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { SubmitChartConstants } from '../store/submitChart.constants'
import { getAuthenticationJwtSelector } from '../../login/selectors/getAuthenticationJwt.selector'
import { SubmitChartService } from '../services/submitChart.service'
import { IFetchPRIDResponse } from '../store/submitChart.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { HttpCodes } from '../../../common/httpCodes.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* updateSubmitChartValidation() {
  const authenticationJwt: string | null = yield select(getAuthenticationJwtSelector)
  const submitChartService = new SubmitChartService(authenticationJwt as string)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const response: IFetchPRIDResponse = yield call([submitChartService, submitChartService.fetchPRID])

    if (response) {
      const { status } = response

      if (status === HttpCodes.UNAUTHORIZED_401 && pcrDoc.submitChart) {
        const pcrDocUpdated = {
          ...pcrDoc,
          submitChart: { ...pcrDoc.submitChart, responseMessage: '' },
        }
        try {
          yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
        } catch (e) {
          yield put(throwPcrException(`updateSubmitChart() error: ${e}`))
        }
      }
    }
  }
}

export function* updateSubmitChartValidationSaga() {
  yield takeLatest(
    [SubmitChartConstants.UPDATE_SUBMIT_CHART_VALIDATION_STATE],
    performWithMutexHOG,
    updateSubmitChartValidation
  )
}
